import { createFileRoute, redirect } from '@tanstack/react-router'
import { useSelectedTenantStore } from '@/stores/useSelectedTenantStore'

// Redirector: /documents/created-by-me -> /org/$orgId/documents/created-by-me
export const Route = createFileRoute(
  '/_authenticated/_dashboard/documents/created-by-me',
)({
  component: () => null,
  beforeLoad: async () => {
    const store = useSelectedTenantStore.getState()
    if (store.selectedTenantId) {
      throw redirect({
        to: '/org/$orgId/documents/created-by-me',
        params: { orgId: store.selectedTenantId },
        search: (prev) => prev,
      })
    }
    throw redirect({ to: '/select-tenant' })
  },
})
